import React, {
  useCallback,
  useState,
  useLayoutEffect,
  Fragment,
  useEffect,
} from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { isAndroid } from "react-device-detect";

import { mainDataSelAPI } from "../../../api/globalAPI";
import { TYPE, URL } from "../../../constant";
import {
  useAsideState,
  useAmplitude,
  useUserInfo,
  useLearningHistory,
  useAppOcrOnOff,
  useLoading,
  useAlert,
} from "../../../hooks";
import { mathpidLogAPICall } from "../../../redux/logData";
import {
  hideLoading,
  myLevel,
  openWebBrowser,
} from "../../../utils/utilityEtc";
import { appsflyer, appsflyerEventName } from "../../../utils/appsflyer";
import { A } from "../../common";
import LocaleChecked from "../../common/test/LocaleChecked";
import PayPopup1 from "../payment/PayPopup1";
import PayPopup3 from "../payment/PayPopup3";
import { setUserProperties } from "../../../redux/amplitude";
import HACKLE_DATA from "../../../constant/HACKLE_DATA";
import useHackleInfo from "../../../hooks/useHackle";
import TutorialTooltip from "./common/TutorialTooltip";
import { appOpenMathFarm } from "../../../utils/appEventFunc";

function GlobalMainV2(props) {
  const logDispatch = useDispatch();
  const history = useHistory();
  const { info } = useUserInfo();
  const { setAmplitudeLog } = useAmplitude();
  const { setAsideState } = useAsideState();
  const { handleOcr } = useAppOcrOnOff();
  const { t, i18n } = useTranslation();
  const { learningHistoryInfo } = useLearningHistory();
  const [mainData, setMainData] = useState(null);
  const [isShowTopicPopup] = useState(false);
  const { clearLoading } = useLoading();
  const { setHackleLog } = useHackleInfo();
  const [Alert] = useAlert();

  useEffect(() => {
    if (!mainData) return;
  }, [mainData]);
  const [tutorialInfo, setTutorialInfo] = useState({
    isShow: false,
    curStep: TYPE.TUTORIAL.STEP1,
  });
  const location = useLocation();
  const { info: hackleInfo, setHackleInfo, clearHackleInfo } = useHackleInfo();
  const getHackle = hackleInfo?.MAIN_GAME_BANNER;

  useLayoutEffect(() => {
    if (!info.learnerId) return;
    mainDataSelAPICall();

    logDispatch(
      mathpidLogAPICall({
        verbId: "accessed",
        objectId: "screen",
        screenVersion: "1.0",
        screenCode: "scr_0000_0000",
      })
    );
  }, [info.learnerId]);

  // useLayoutEffect(() => {
  //   hideLoading();
  // }, [])

  const mainDataSelAPICall = useCallback(async () => {
    try {
      const { learnerId, entryType, userId } = info;
      let resp = await mainDataSelAPI({
        lrnMbrId: learnerId,
        channel: entryType,
      });
      // 결제 show 조건 값
      resp.isShowPayment = info.isPaymentCountry;
      setMainData(resp);
      const level = myLevel(info.learnerBirth);
      logDispatch(
        setUserProperties({
          property_name: "일반 정보",
          userId: userId,
          info: {
            current_email: info?.userEmail,
            current_nickname: info?.learnerName,
            self_rated_level: info?.learnerBirth,
            account_creation_date: info?.rgtnDt,
            "자가 진단 수학 수준": level,
          },
          aiTest: {
            "진단test 이행 여부": resp?.dgnsYn === "Y" ? "Y" : "N",
            "진단test level": "",
            "현재 level": resp?.lvlInfo?.dspOdr,
          },
          lrnCmnInfo: {
            "첫 방문 일자": resp?.lrnCmnInfo.firVitDt,
            "최근 방문 일자": resp?.lrnCmnInfo.lastVitDt,
            "첫 학습 일자": resp?.lrnCmnInfo.firLenDt,
            "최근 학습 일자": resp?.lrnCmnInfo.lastLenDt,
          },
          subscribeInfo: {
            "Premium 여부":
              info?.isPaymentCountry && info?.subScriptionPurchsYn ? "Y" : "N",
          },
        })
      );

      if (window.location.pathname === URL.SELECT_LEARNING) {
        setAmplitudeLog({
          eventName: {
            name: "메인화면 조회",
            event: {
              소스화면: "",
              "현재 level": resp?.lvlInfo?.dspOdr,
              "Plan 현황":
                info?.isPaymentCountry && info?.subScriptionPurchsYn
                  ? "Premium"
                  : "Limited",
            },
          },
        });
      }

      appsflyer({
        eventName: appsflyerEventName.mainpage_viewed,
        eventParams: null,
      });

      if (info?.subScriptionPurchsYn) {
        setHackleLog(HACKLE_DATA.TYPE.PURCHASE_COMPLETE); // premium 전환 화면 조회
      }
    } catch (error) {
      // clearLoading();
      console.log("%c##### Error-mainDataSelAPICall: ", "color: red", error);
    } finally {
      hideLoading();
      clearLoading();
    }
  }, [info]);

  const handleMenuOpen = useCallback(async () => {
    setAsideState({ menu: true });
    setAmplitudeLog({ eventCategory: "app_usage", eventName: "메인메뉴 조회" });
  }, []);

  const handlePage = useCallback(
    (path, type) => {
      switch (path) {
        case URL.COURSE_LEARNING.LEARNING_NOTE:
          sessionStorage.removeItem("state");
          if (learningHistoryInfo.isCompleteAIDiagnosis === "N") {
            path = {
              pathname: path,
              state: "theme",
            };
          }
          break;
        case URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.DIAGNOSIS_GUIDE1:
          if (learningHistoryInfo.isCompleteAIDiagnosis === "Y") {
            path = URL.COURSE_LEARNING.LIST;
          }

          break;
        case URL.PAYMENT.SUBSCRIBE:
          break;
        case URL.PAYMENT.SUBSCRIBE_NEW:
          break;
        case URL.TOPIC_LEARNING:
          setAsideState({ tab: "topic" });
          break;
      }

      switch (type) {
        case "video":
          path = {
            pathname: path,
            state: "video",
          };
          setAmplitudeLog({
            eventCategory: "main",
            eventName: "메인컨셉비디오 클릭",
            isHackleSend: true,
          });
          break;
        case "worksheet":
          path = {
            pathname: path,
            state: "worksheet",
          };
          setAmplitudeLog({
            eventCategory: "main",
            eventName: "메인 워크시트 클릭",
          });
          appsflyer({
            eventName: appsflyerEventName.worksheet_mainclick,
            eventParams: null,
          });
          break;
        case "mathFarm":
          setAmplitudeLog({ eventCategory: "main", eventName: "매쓰팜" });
          appsflyer({
            eventName: appsflyerEventName.maingame_click,
            eventParams: null,
          });
          setHackleLog(HACKLE_DATA.TYPE.MATHFARM_CLICK);
          appOpenMathFarm();
          break;
      }

    switch (type) {
      case 'video':
        path = {
          pathname: path,
          state: 'video'
        }
        setAmplitudeLog({ eventCategory: 'main', eventName: '메인컨셉비디오 클릭',isHackleSend: true });
        break;
      case 'worksheet':
        path = {
          pathname: path,
          state: 'worksheet'
        }
        setAmplitudeLog({ eventCategory: 'main', eventName: '메인 워크시트 클릭' });
        appsflyer({
          eventName: appsflyerEventName.worksheet_mainclick,
          eventParams: null
        });
        break;
      case 'mathFarm':
        
        setAmplitudeLog({ eventCategory: 'main', eventName: '매쓰팜' });
        appsflyer({
          eventName: appsflyerEventName.maingame_click,
          eventParams: null
        });

        appOpenMathFarm();
        break;
    }
    
    history.push(path);
  }, [info]);

  const handleToolTip = () => {
    setTutorialInfo((prevState) => {
      let step = prevState.curStep;
      let nextStep = "";

      if (step === TYPE.TUTORIAL.STEP3) {
        // 초기화
        localStorage.setItem("gb_tutorial", "Y");
        return {
          ...prevState,
          isShow: false,
          curStep: TYPE.TUTORIAL.STEP1,
        };
      } else {
        nextStep = "step" + (Number(step.slice(4)) + 1);
      }

      return {
        ...prevState,
        curStep: nextStep,
      };
    });
  };

  React.useEffect(() => {
    if (location.state?.prevPoint === "init_appLogin") {
      const isTutorialView = localStorage.getItem("gb_tutorial");
      const isShowHackle = !isTutorialView || isTutorialView === "N";

      // 메뉴 안내 듀토리얼 A/B 테스트
      setHackleInfo({
        viewPath: "MAIN_TUTORIAL_GUIDE",
        isShowHackle, // isShowHackle 조건
      });
    }
  }, [location]);

  React.useEffect(() => {
    let getHackleInfo = hackleInfo?.MAIN_TUTORIAL_GUIDE;
    const isTutorialView = localStorage.getItem("gb_tutorial");

    if ((!isTutorialView || isTutorialView !== "Y") && getHackleInfo) {
      setTutorialInfo({
        ...tutorialInfo,
        isShow: getHackleInfo?.isShowHackle && getHackleInfo?.variation === "B",
      });
    }

    getHackleInfo = hackleInfo?.MAIN_GAME_BANNER;
    if (getHackleInfo?.isShowHackle) {
      if (
        process.env.REACT_APP_ENV === "local" ||
        process.env.REACT_APP_ENV === "development"
      ) {
        Alert(
          `Hackle A/B TEST<br/><br/>${getHackleInfo.resason}<br/> TYPE : ${getHackleInfo.variation}`
        );
      }
    }
  }, [hackleInfo]);

  if (!mainData) return <div></div>;

  return (
    <div className="layout-def bg_gray3 gb renew">
      <div className="header global_main js_scroll_head">
        <div className="inner">
          <div className="upper_wrap">
            <div>
              <a className="logo_btn" href="#null">
                <img src="./static/images/icon/img_logo.svg" alt="" />
              </a>
            </div>
            <div className="right">
              <div className="btn_wrap">
                {/* 로그인 버튼 */}
                {info.memberType === TYPE.GB_USER_TYPE.GUEST && (
                  <button
                    type="button"
                    onClick={() => handlePage(URL.ACCOUNT.LOGIN)}
                  >
                    <img
                      src="./static/images/payment/ic_pay_login.svg"
                      alt="login"
                    />
                  </button>
                )}
                <button type="button" onClick={handleMenuOpen}>
                  <img
                    src="./static/images/icon/btn_menu_th.svg"
                    alt="전체 메뉴"
                  />
                </button>
              </div>
            </div>
          </div>

          <div className="cont w660">
            <div className="left">
              <img
                className="user"
                src="./static/images/common/img_profilecha_th_01.svg"
                alt=""
              />
            </div>
            <div className="right">
              <div className="nickname">
                <span className="ellipsis">{info.learnerName}</span>
                <button
                  type="button"
                  className="btn_white"
                  onClick={() => handlePage(URL.ACCOUNT.MY_PAGE)}
                >
                  {t("LC_01_02-GB.msg030")}
                </button>
              </div>
              {(process.env.REACT_APP_ENV === "development" ||
                process.env.REACT_APP_ENV === "local") && <LocaleChecked />}
              {mainData.isShowPayment && (
                <>
                  {/* 결제 OFF */}
                  {!info.subScriptionPurchsYn && (
                    <button
                      type="button"
                      className="btn_lp"
                      onClick={() =>
                        handlePage(
                          info?.countryCd === TYPE.COUNTRY_CODE.KOREA
                            ? URL.PAYMENT.SUBSCRIBE
                            : URL.PAYMENT.SUBSCRIBE_NEW
                        )
                      }
                    >
                      {t("LC_01_02-GB.msg038")}
                    </button>
                  )}
                  {/* 결제 ON */}
                  {info.subScriptionPurchsYn && (
                    <button type="button" className="btn_pr">
                      {t("LC_01_02-GB.msg039")}
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div
          className={`gl_main_theme_wrap ${
            tutorialInfo.isShow ? "tutorial" : ""
          }`}
        >
          <div className="theme_box">
            {/* 결제불가 */}
            {!mainData.isShowPayment && (
              <Fragment>
                <A
                  className={`box1 ${
                    tutorialInfo.isShow &&
                    tutorialInfo.curStep === TYPE.TUTORIAL.STEP1
                      ? "on"
                      : ""
                  }`}
                  onClick={() =>
                    handlePage(
                      URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.DIAGNOSIS_GUIDE1
                    )
                  }
                >
                  <span className="tit">{t("LC_01_02-GB.msg009")}</span>
                  <span className="btn pos">{t("LC_01_02-GB.msg031")}</span>
                </A>
                {/* 튜토리얼 툴팁 STEP1 */}
                <TutorialTooltip
                  isShow={tutorialInfo.isShow}
                  setStep={TYPE.TUTORIAL.STEP1}
                  curStep={tutorialInfo.curStep}
                  onClick={handleToolTip}
                />
              </Fragment>
            )}
            {/* 결제가능 */}
            {mainData.isShowPayment && (
              <>
                {!info.subScriptionPurchsYn && (
                  <Fragment>
                    <A
                      className={`box1 lock ${
                        tutorialInfo.isShow &&
                        tutorialInfo.curStep === TYPE.TUTORIAL.STEP1
                          ? "on"
                          : ""
                      }`}
                      href="#null"
                      onClick={() =>
                        handlePage(
                          info?.countryCd === TYPE.COUNTRY_CODE.KOREA
                            ? URL.PAYMENT.SUBSCRIBE
                            : URL.PAYMENT.SUBSCRIBE_NEW
                        )
                      }
                    >
                      <span className="tit lock">
                        {t("LC_01_02-GB.msg035")}
                      </span>
                      <p
                        className="txt"
                        dangerouslySetInnerHTML={{
                          __html: t("LC_01_02-GB.msg036"),
                        }}
                      />
                      <span className="btn lock pos">
                        {t("LC_01_02-GB.msg037")}
                      </span>
                    </A>
                    {/* 튜토리얼 툴팁 STEP1 */}
                    <TutorialTooltip
                      isShow={tutorialInfo.isShow}
                      setStep={TYPE.TUTORIAL.STEP1}
                      curStep={tutorialInfo.curStep}
                      onClick={handleToolTip}
                    />
                  </Fragment>
                )}
                {info.subScriptionPurchsYn && (
                  <Fragment>
                    <A
                      className="box1"
                      href="#null"
                      onClick={() =>
                        handlePage(
                          URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.DIAGNOSIS_GUIDE1
                        )
                      }
                    >
                      <span className="tit">{t("LC_01_02-GB.msg043")}</span>
                      <p
                        className="txt"
                        dangerouslySetInnerHTML={{
                          __html: t("LC_01_02-GB.msg044"),
                        }}
                      />
                      <span className="btn pos">{t("LC_01_02-GB.msg045")}</span>
                    </A>
                    {/* 튜토리얼 툴팁 STEP1 */}
                    <TutorialTooltip
                      isShow={tutorialInfo.isShow}
                      setStep={TYPE.TUTORIAL.STEP1}
                      curStep={tutorialInfo.curStep}
                      onClick={handleToolTip}
                    />
                  </Fragment>
                )}
              </>
            )}

            <A
              className={`box2 ${
                tutorialInfo.isShow &&
                tutorialInfo.curStep === TYPE.TUTORIAL.STEP2
                  ? "on"
                  : ""
              }`}
              onClick={() => handlePage(URL.TOPIC_LEARNING)}
            >
              <span>{t("LC_01_02-GB.msg019")}</span>
              {i18n.language === "en" && <p className="txt">Question Bank</p>}
            </A>
            {/* 튜토리얼 툴팁 STEP2 */}
            <TutorialTooltip
              isShow={tutorialInfo.isShow}
              setStep={TYPE.TUTORIAL.STEP2}
              curStep={tutorialInfo.curStep}
              onClick={handleToolTip}
            />
            <A
              className={`box3 ${
                tutorialInfo.isShow &&
                tutorialInfo.curStep === TYPE.TUTORIAL.STEP3
                  ? "on"
                  : ""
              }`}
              onClick={handleOcr}
            >
              <span
                dangerouslySetInnerHTML={{ __html: t("LC_01_02-GB.msg028") }}
              />
            </A>
            {/* 튜토리얼 툴팁 STEP3 */}
            <TutorialTooltip
              isShow={tutorialInfo.isShow}
              setStep={TYPE.TUTORIAL.STEP3}
              curStep={tutorialInfo.curStep}
              onClick={handleToolTip}
            />
          </div>
          <div className="banner_boxes">
            <A
              className="bnr_box ic_dn"
              onClick={() => handlePage(URL.TOPIC_LEARNING, "worksheet")}
            >
              <span>{t("LC_01_02-GB.msg047")}</span>
            </A>
            <A
              className="bnr_box ic_media"
              onClick={() => handlePage(URL.TOPIC_LEARNING, "video")}
            >
              <span>{t("LC_01_02-GB.msg046")}</span>
            </A>
            {/* A */}
            {getHackle?.variation === "A" && (
              <div className="bnr_game">
                <A onClick={() => handlePage("", "mathFarm")}>
                  <figure className="img">
                    <img
                      src="./static/images/common/img_thum_game.png"
                      alt=""
                    />
                  </figure>
                  <div className="txt_area">
                    <div className="txt">
                      <strong className="tit">{t("LC_01_02-GB.msg048")}</strong>
                      <p className="desc">{t("LC_01_02-GB.msg049")}</p>
                    </div>
                    <span className="guide_btn">{t("LC_01_02-GB.msg050")}</span>
                  </div>
                </A>
              </div>
            )}
            {/* B */}
            {getHackle?.variation === "B" && (
              <div className="bnr_game_v2">
                <A onClick={() => handlePage("", "mathFarm")}>
                  <div className="txt_area">
                    <div className="txt">
                      <strong className="tit">{t("LC_01_02-GB.msg048")}</strong>
                      <p className="desc">{t("LC_01_02-GB.msg049")}</p>
                    </div>
                    <span className="guide_btn">{t("LC_01_02-GB.msg050")}</span>
                  </div>
                </A>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* 배너 */}
      {/* <div className="bottom_wrap">
        <A href="#null" className="box_btn" onClick={() => handlePage(URL.COURSE_LEARNING.LEARNING_NOTE)}>
            <span className="inner_box cls">
                <span className="left">
                  { 
                    i18n.language === "ko" && 
                    <>
                      <p className="txt1">{t('LC_01_02-GB.msg040')}</p>
                      <span className="txt2">{t('LC_01_02-GB.msg041')}</span>
                    </>
                  }
                  {
                    i18n.language === "en" && 
                    <span className="txt2" dangerouslySetInnerHTML={{ __html: t('LC_01_02-GB.msg041') }}/>
                  }
                  
                </span>
                <span className="right">
                    <span className="hide_m btm_txt">{t('LC_01_02-GB.msg042')}</span>
                    <img src="./static/images/icon/ic_rnd_arrow.svg" alt=""/>
                </span>
            </span>
        </A>
      </div> */}

      {/* 재방문 팝업 */}
      {mainData.isShowPayment && !info.subScriptionPurchsYn && <PayPopup3 />}
      {/* 주제학습 재방문 팝업 */}
      {/* { mainData.isShowPayment && !info.subScriptionPurchsYn && isShowTopicPopup && <PayPopup1 /> } */}
    </div>
  );
}

export default GlobalMainV2;
